// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__mAoEk","row":"styles_row__av9ts"};